import { render, staticRenderFns } from "./app-image.vue?vue&type=template&id=cc465254&scoped=true&"
import script from "./app-image.vue.ts?vue&type=script&lang=ts&"
export * from "./app-image.vue.ts?vue&type=script&lang=ts&"
import style0 from "./app-image.vue?vue&type=style&index=0&id=cc465254&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc465254",
  null
  
)

export default component.exports